import { Trash2 } from "lucide-react";

export const SelectionBar = ({ total, selected, onSelectAll, onClear, onDelete }) => total > 0 && (
  <div className="mt-5 flex flex-wrap items-center justify-between gap-2 rounded-xl border bg-card px-3 py-2 text-sm" data-testid="lead-selection-bar">
    <div className="flex items-center gap-3">
      <button type="button" onClick={selected === total ? onClear : onSelectAll} className="font-medium text-foreground underline-offset-2 hover:underline" data-testid="lead-select-all-button">
        {selected === total ? "Clear selection" : "Select all"}
      </button>
      <span className="text-muted-foreground" data-testid="lead-selected-count">{selected} selected</span>
    </div>
    <button type="button" disabled={selected === 0} onClick={onDelete} data-testid="lead-delete-selected-button"
      className="flex h-9 items-center gap-2 rounded-lg bg-red-600 px-3 font-semibold text-white transition-opacity disabled:opacity-40">
      <Trash2 className="h-4 w-4" />Delete selected{selected ? ` (${selected})` : ""}
    </button>
  </div>
);
